import { computed, onUnmounted } from "vue";
import { ShortcutType } from "@/generated/models";
import { clearPreviewDiagramSelectionObject, previewDiagramSelectionObject } from "../../interop/dotnetExports/bridge";
import { useCurrentFileContext } from "../../useCurrentFileContext";

export function usePreviewDiagramSelectionObject() {
  const { type } = useCurrentFileContext();

  const isSupported = computed(() => {
    return type.value === ShortcutType.Whiteboard || type.value === ShortcutType.Design;
  });

  function preview(id: string) {
    if (!isSupported.value) return;
    previewDiagramSelectionObject(id);
  }

  function clear() {
    if (!isSupported.value) return;
    clearPreviewDiagramSelectionObject();
  }

  onUnmounted(() => {
    clear();
  });

  return {
    isSupported,
    preview,
    clear,
  };
}
